var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEnabled1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H28C33.5228 0 38 4.47715 38 10V28C38 33.5228 33.5228 38 28 38H10C4.47715 38 0 33.5228 0 28V10Z",
    fill: "#5921F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6912 25.4538C20.7165 25.5169 20.7605 25.5708 20.8174 25.6082C20.8742 25.6455 20.9411 25.6646 21.0091 25.6629C21.0771 25.6611 21.1429 25.6386 21.1977 25.5984C21.2526 25.5582 21.2938 25.5021 21.3159 25.4378L25.6492 12.7711C25.6705 12.7121 25.6746 12.6481 25.6609 12.5868C25.6473 12.5255 25.6164 12.4694 25.572 12.425C25.5276 12.3806 25.4715 12.3497 25.4102 12.3361C25.3489 12.3224 25.2849 12.3265 25.2259 12.3478L12.5592 16.6811C12.4949 16.7032 12.4388 16.7444 12.3986 16.7992C12.3583 16.8541 12.3358 16.9199 12.3341 16.9879C12.3324 17.0559 12.3515 17.1228 12.3888 17.1796C12.4262 17.2364 12.4801 17.2805 12.5432 17.3058L17.8299 19.4258C17.997 19.4927 18.1488 19.5928 18.2762 19.7199C18.4036 19.8471 18.504 19.9988 18.5712 20.1658L20.6912 25.4538Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5687 12.4297L18.2754 19.7224",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEnabled1);
export default __webpack_public_path__ + "static/media/SendEnabled1.fdc6848e130d79d608b81529226d7ef5.svg";
export { ForwardRef as ReactComponent };